<template>
    <div class="GlobalMessages">
        <template v-for="(message, index) in messages">
            <transition name="message-toast">
                <div class="GlobalMessages__toast">
                    <div class="GlobalMessages__close" @click="removeMessage(index)"></div>
                    {{message}}
                </div>
            </transition>
        </template>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'GlobalMessages',
        computed: {
            ...mapState({
                messages: s => s.settings.messages,
            })
        },
        methods: {
            ...mapActions({
                removeMessage: 'settings/removeMessage'
            })
        }
    };
</script>

<style>
    .GlobalMessages {
        position: fixed;
        bottom: 10px;
        right: 10px;
        width: 100%;
        max-width: 400px;
        z-index: 99999
    }

    @media (max-width: 599px) {
        .GlobalMessages {
            width: 100%;
            max-width: 100%;
            bottom: 0;
            right: 0
        }
    }

    .GlobalMessages__toast {
        position: relative;
        color: #fff;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
        background: rgba(0,188,212,.7);
        padding: 16px;
        margin-top: 10px
    }

    .GlobalMessages__close {
        cursor: pointer;
        position: absolute;
        right: 5px;
        top: 5px;
        width: 14px;
        height: 14px;
        transition: opacity .15s ease-in-out;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden
    }

        .GlobalMessages__close:after, .GlobalMessages__close:before {
            content: "";
            position: absolute;
            top: 6px;
            width: 14px;
            height: 2px;
            background-color: #fff
        }

        .GlobalMessages__close:before {
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg)
        }

        .GlobalMessages__close:after {
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg)
        }


    /*Transition*/
    .message-toast-enter-active {
        opacity: 0;
        transition: all .2s ease-out
    }

    .message-toast-enter-to {
        opacity: 1
    }

    .message-toast-leave-active {
        opacity: 1;
        transition: all .1s ease-out
    }

    .message-toast-leave-to {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// GlobalMessages.vue?22a2f17d